var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchool = function SvgSchool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "school_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 21-7-3.8v-6L1 9l11-6 11 6v8h-2v-6.9l-2 1.1v6zm0-8.3L18.85 9 12 5.3 5.15 9zm0 6.025 5-2.7V12.25L12 15l-5-2.75v3.775z"
  })));
};
export { SvgSchool as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTIgMjFMNSAxNy4yVjExLjJMMSA5TDEyIDNMMjMgOVYxN0gyMVYxMC4xTDE5IDExLjJWMTcuMkwxMiAyMVpNMTIgMTIuN0wxOC44NSA5TDEyIDUuMzAwMDVMNS4xNSA5TDEyIDEyLjdaTTEyIDE4LjcyNUwxNyAxNi4wMjVWMTIuMjVMMTIgMTVMNyAxMi4yNVYxNi4wMjVMMTIgMTguNzI1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";